import { React, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { SkillTable, SkillCreate } from "..";


function SkillsSearch() {
  const [skillName, setSkillName] = useState("");

  const [skills, setSkills] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showSkillsSearchResults();
  }, [skillName, updateTable]);

  const showSkillsSearchResults = () => {
    const body = new FormData();
    body.append("skillName", skillName);

    axios.post("/company/searchSkills", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setSkills(data.skills);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setSkillName("");
  };

  return (
    <div className="SkillsSearch bg-brand-tertiary h-full">
      <div className="SkillsSearch-container flex flex-col p-8 h-full">
        <div className="SkillsSearch-topContainer flex flex-wrap">
          <div className="SkillsSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={skillName}
              onChange={(e) => setSkillName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <SkillCreate updateTable={updateTable} setUpdateTable={setUpdateTable} />

          <button type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2" onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="SkillsSearch-bottomContainer flex w-full h-full">
          <SkillTable skills={skills} updateTable={updateTable} setUpdateTable={setUpdateTable} />
        </div>
      </div>
    </div>
  );
}

export default SkillsSearch;
